import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import ClientConfig from '@/clients/entities/client-config'
import ClientConfigFilter from '@/clients/entities/client-config-filter'

class ClientConfigService {
  public async findAllProductiveAsync() {
    const res = await axios.post<ClientConfig[]>(`clientconfigs/productive`)
    return Responses.list(res)
  }

  public async findAllFilteredAsync(request: ClientConfigFilter) {
    const res = await axios.post<PaginationResponse<ClientConfig>>(
      `clientconfigs/filter`,
      request
    )
    return Responses.pagedList(res)
  }

  public async createAsync(entity: ClientConfig) {
    const res = await axios.post<ClientConfig>(`clientconfigs`, entity)
    return Responses.obj(res)
  }

  public async updateAsync(entity: ClientConfig) {
    const res = await axios.put<ClientConfig>(
      `clientconfigs/${entity.clientId}`,
      entity
    )
    return Responses.obj(res)
  }

  public async removeAsync(id: string) {
    await axios.delete(`clientconfigs/${id}`)
  }

  public async migrate(id: string) {
    const res = await axios.post<string>(`clientconfigs/migrate/${id}`)
    return Responses.obj(res)
  }
}

export default new ClientConfigService()
